import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["render"],
  _excluded2 = ["Root", "styles", "children", "Children", "forwardRef"];
import React from 'react';
import assignProps from "../../assignProps.mjs";
import { useForkRef } from "../../ref.mjs";
function createRootRender() {
  // @ts-ignore
  var Root = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var Tag = _ref.render,
      source = _objectWithoutProperties(_ref, _excluded);
    var _Root$props = Root.props,
      _Root = _Root$props.Root,
      styles = _Root$props.styles,
      children = _Root$props.children,
      Children = _Root$props.Children,
      _Root$props$forwardRe = _Root$props.forwardRef,
      forwardRef = _Root$props$forwardRe === void 0 ? null : _Root$props$forwardRe,
      props = _objectWithoutProperties(_Root$props, _excluded2);
    var clearProps = Object.entries(props).reduce(function (props, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        name = _ref3[0],
        value = _ref3[1];
      if (value !== undefined) {
        props[name] = value;
      }
      return props;
    }, {});
    var child = {};
    // TODO: need to find better check solution (by lsroman)
    if (typeof Children.origin !== 'undefined') {
      // @ts-ignore
      child.children = /*#__PURE__*/React.createElement(Children, null);
    }
    var other = assignProps(_objectSpread(_objectSpread({}, clearProps), {}, {
      ref: useForkRef(forwardRef, ref)
    }), _objectSpread(_objectSpread({}, child), source));
    if (!Tag) {
      throw new Error('`render` prop of Root is not provided');
    }
    if (Tag === React.Fragment) return /*#__PURE__*/React.createElement(React.Fragment, null, other.children);
    return /*#__PURE__*/React.createElement(Tag, other);
  });
  // @ts-ignore
  Root.props = {};
  return Root;
}
function Enhancement() {
  return {
    init: function init() {
      this.Root = createRootRender();
    },
    asProps: function asProps(props, WrapperComponent, isFunction) {
      if (isFunction) {
        return _objectSpread(_objectSpread({}, props), {}, {
          Root: this.Root
        });
      }
      return props;
    },
    render: function render(_render, props) {
      this.Root.props = props;
      return _render;
    }
  };
}
export default Enhancement;
//# sourceMappingURL=Root.mjs.map